<template>
  <b-container fluid>
    <b-modal title="Nuevo Devengado" id="my-modal" size="md" hide-footer>
      <form @submit.prevent="saveData">
        <div class="row px-5">
          <div class="col-md-12">
            <div class="mb-4">
              <p>
                Los devengados que creas aquí son los que te saldrán al momento
                de gestionar la nómina de tus empleados.
              </p>
              <div>
                <label class="form-label mt-3">Tipo de devengado</label>
                <b-form-input v-model="item.descripcion" type="text" placeholder="Ejemplo: Salario"
                  required></b-form-input>
              </div>
              <div>
                <label class="form-label mt-3">Formula</label>
                <b-form-input v-model="item.formula" type="text" placeholder="Ejemplo: (salario * dias) / 30"
                  required></b-form-input>
              </div>
              <div>
                <label class="form-label mt-3">Campos</label>
                <b-form-input v-model="item.campos" type="text" placeholder="Ejemplo: dias, horas"
                  required></b-form-input>
              </div>
              <div v-if="validar(item.campos)" class="form-label mt-3">
                <label>El porcentaje tiene valor especificos </label>
                <b-form-checkbox v-model="item.porcentaje"></b-form-checkbox>
              </div>
              <div v-if="item.porcentaje === true" class="form-label mt-3">
                <label>Valores del porcentaje</label>
                <b-form-input v-model="item.porcentajes" type="text" placeholder="Ejemplo: 45, 23"
                  required></b-form-input>
              </div>
              <div class="d-flex justify-content-between" style="flex-wrap: wrap;">
                <div style="width: 48%">
                  <label class="form-label mt-3">¿Esta novedad implica una ausencia laboral del empleado?</label>
                  <b-form-checkbox v-model="item.Laborado" required></b-form-checkbox>
                </div>
                <div stryle="width: 48%">
                  <label class="form-label mt-3">¿Afecta el calulo de la Salud?</label>
                  <b-form-checkbox v-model="item.salud" required></b-form-checkbox>
                </div>
              </div>
              <div>
                <label class="form-label mt-3">¿Afecta el calulo de la Pension?</label>
                <b-form-checkbox v-model="item.pension" required></b-form-checkbox>
              </div>
              <div>
                <label class="form-label mt-3">Novedad Dian</label>
                <b-form-select v-model="item.NovedadesDian" :options="listaNovedadesDian" value-field="descripcion"
                  text-field="descripcion" required>
                  <template #first>
                    <b-form-select-option selected value="null" disabled>
                      -- Seleccionar --
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
        <!-- <template #modal-footer> -->
        <div class="w-100 text-right">
          <button type="submit" class="mx-1 btn px-4 py-2 btn-primary">
            Guardar Devengado
          </button>
          <button class="mx-1 btn px-4 py-2 btn-secondary" @click="$bvModal.hide('my-modal')">
            Cancelar
          </button>
        </div>
        <!-- </template> -->
      </form>
    </b-modal>
    <b-modal title="Editar Devengado" id="my-modal-editar" size="md" hide-footer>
      <form @submit.prevent="editarDataSave">
        <div class="row px-5">
          <div class="col-md-12">
            <div class="mb-4">
              <div>
                <label class="form-label mt-3">Tipo de devengado</label>
                <b-form-input v-model="itemeditar.descripcion" type="text" placeholder="Ejemplo: Salario"
                  required></b-form-input>
              </div>
              <div>
                <label class="form-label mt-3">Formula</label>
                <b-form-input v-model="itemeditar.formula" type="text" placeholder="Ejemplo: (salario * dias) / 30"
                  required></b-form-input>
              </div>
              <div>
                <label class="form-label mt-3">Campos</label>
                <b-form-input v-model="itemeditar.campos" type="text" placeholder="Ejemplo: dias, horas"
                  required></b-form-input>
              </div>
              <div v-if="validar(itemeditar.campos)" class="form-label mt-3">
                <label>El porcentaje tiene valor especificos </label>
                <b-form-checkbox v-model="itemeditar.porcentaje"></b-form-checkbox>
              </div>
              <div v-if="itemeditar.porcentaje === true" class="form-label mt-3">
                <label>Valores del porcentaje</label>
                <b-form-input v-model="itemeditar.porcentajes" type="text" placeholder="Ejemplo: 45, 23"
                  required></b-form-input>
              </div>
              <div class="d-flex justify-content-between" style="flex-wrap: wrap;">
                <div style="width: 48%">
                  <label class="form-label mt-3">¿Esta novedad implica una ausencia laboral del empleado?</label>
                  <b-form-checkbox v-model="itemeditar.Laborado" required></b-form-checkbox>
                </div>
                <div style="width: 48%">
                  <label class="form-label mt-3">¿Afecta el calulo de la Salud?</label>
                  <b-form-checkbox v-model="itemeditar.salud" required></b-form-checkbox>
                </div>
              </div>
              <div>
                <label class="form-label mt-3">¿Afecta el calulo de la Pension?</label>
                <b-form-checkbox v-model="itemeditar.pension" required></b-form-checkbox>
              </div>
              <div>
                <label class="form-label mt-3">Novedad Dian</label>
                <b-form-select v-model="itemeditar.novedadesDian" :options="listaNovedadesDian"
                  value-field="descripcion" text-field="descripcion" required>
                  <template #first>
                    <b-form-select-option selected value="null" disabled>
                      -- Seleccionar --
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 text-right">
          <button type="submit" class="mx-1 btn px-4 py-2 btn-primary">
            Editar Devengado
          </button>
          <button class="mx-1 btn px-4 py-2 btn-secondary"
            @click.prevent="$bvModal.hide('my-modal-editar'), itemeditar = {}">
            Cancelar
          </button>
        </div>
      </form>
    </b-modal>
    <b-row>
      <b-col sm="12">
        <card>
          <template v-slot:headerTitle>
            <h4 class="card-title"><b>DEVENGADOS</b></h4>
          </template>
          <div class="text-right px-4 mt-3">
            <!--   -->
            <!-- <b-button v-b-modal.my-modal @click="infoForPerson(item)">Ver más</b-button> -->
            <button v-b-modal.my-modal class="mx-1 btn btn-success">
              <i class="fas fa-plus"></i>Agregar Devengado
            </button>
          </div>
          <div class="table-responsive-md px-4 mt-3">
            <table id="datatable_departamentos"
              class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th style="min-width: 25rem">Devengado</th>
                  <!-- <th>Estado</th> -->
                  <th style="min-width: 7rem">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listaItems" :key="item.id">
                  <td style="min-width: 25rem">{{ item.descripcion }}</td>
                  <!-- <td>{{ item.estado == true ? "Activo" : "Inactivo" }}</td> -->

                  <!-- <td>{{ item.sucursal.descripcion }}</td> -->
                  <td style="min-width: 7rem">
                    <span class="pointer">
                      <i @click="editarData(item.id)" class="fas fa-solid fa-pencil px-1 text-success mr-1"></i>
                    </span>
                    <span class="pointer">
                      <i @click="deleteRow(item.id)" class="fas fa-solid fa-trash px-1 text-danger"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from "../../../../config/pluginInit";
const Swal = require("sweetalert2");

export default {
  name: "DataTable",
  data() {
    return {
      listaItems: [],
      logoEmpresa: "",
      usuario: {},
      listaDevengados: [],
      item: {},
      itemeditar: {},
      listaNovedadesDian: [],
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      await this.getData();
      core.index();
      window.$("#datatable_departamentos").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
      this.$isLoading(false);
    } catch (error) {
      this.$isLoading(false);
      console.log("error", error);
    }
  },
  methods: {
    validar(campo) {
      if (campo?.includes("porcentaje")) {
        return true;
      }
      return false;
    },
    async editarData(Id) {
      let response = await this.$store.dispatch("hl_get", {
        path: "ListaDevengado/GetListaDevengadoById/" + Id,
      });
      let porcentaje = response.porcentajes ? true : false;
      response.campos = response.campos ? eval(response.campos).join(", ") : "";
      response.porcentajes = response.porcentajes
        ? eval(response.porcentajes).join(", ")
        : "";
      this.itemeditar = response;
      this.itemeditar.porcentaje = porcentaje;
      this.$bvModal.show("my-modal-editar");
    },
    async editarDataSave() {
      try {
        let send = {
          Eliminado: false,
          EmpresaId: this.usuario.empresa.id,
          campos: JSON.stringify(this.itemeditar.campos.split(",")),
          descripcion: this.itemeditar.descripcion,
          formula: this.itemeditar.formula,
          porcentajes: this.itemeditar.porcentajes ? JSON.stringify(this.itemeditar.porcentajes?.split(",")) : null,
          NovedadesDian: this.itemeditar.novedadesDian,
          Laborado: this.itemeditar.laborado,
          Salud: this.itemeditar.salud,
          Pension: this.itemeditar.pension,
        };

        let res = await this.$store.dispatch("hl_post", {
          path: "ListaDevengado/EditarDevengado/" + this.itemeditar.id,
          data: send,
        });
        if (res.respuesta) {
          this.getData();
          Swal.fire("Listo!", res.mensaje, "success");
          this.$bvModal.hide("my-modal-editar");
          return;
        }
        Swal.fire("Error!", res.mensaje, "error");
      } catch (error) {
        Swal.fire("Error!", "Error interno del servidor", "error");
        console.log("err", error);
      }
    },
    async saveData() {
      try {
        let send = {
          Eliminado: false,
          EmpresaId: this.usuario.empresa.id,
          campos: JSON.stringify(this.item.campos.split(",")),
          descripcion: this.item.descripcion,
          formula: this.item.formula,
          porcentajes: JSON.stringify(this.item.porcentajes?.split(",")),
          NovedadesDian: this.item.NovedadesDian,
          Laborado: this.item.Laborado,
          Salud: this.itemeditar.salud,
          Pension: this.itemeditar.pension,
        };

        let res = await this.$store.dispatch("hl_post", {
          path: "Devengado/Devengado",
          data: send,
        });
        if (res.respuesta) {
          this.getData();
          Swal.fire("Listo!", res.message, "success");
          this.$bvModal.hide("my-modal");
          return;
        }
        Swal.fire("Error!", res.message, "error");
      } catch (error) {
        Swal.fire("Error!", "Error interno del servidor", "error");
        console.log("err", error);
      }
    },
    async deleteRow(id) {
      Swal.fire({
        title: "Seguro eliminar registro?",
        text: "Después de eliminarlo no podrás recuperarlo!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let result = await this.$store.dispatch("hl_delete", {
            path: "Devengado/EliminarDevengado/" + id,
          });

          if (!result.respuesta) {
            Swal.fire("Error!", result.mensaje, "error");
            return;
          }

          await this.getData();

          Swal.fire("Listo!", result.mensaje, "success");
        }
      });
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Devengado/GetDevengados/" + this.usuario.empresa.id,
        });
        let resNovedades = await this.$store.dispatch("hl_get", {
          path: "NovedadesDian/GetNovedadesDianAll/2",
        });
        console.log("lista devengados Dias... ", resNovedades.data);
        if (res.length > 0) {
          this.listaItems = res;
        } else {
          this.listaItems = [];
        }
        if (resNovedades.data.length > 0) {
          this.listaNovedadesDian = resNovedades.data;
        } else {
          this.listaNovedadesDian = [];
        }
      } catch (error) {
        this.listaItems = [];
        console.log("err", error);
      }
    },
  },
};
</script>
